import React, { useCallback, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { VectorMap } from "@south-paw/react-vector-maps"
import qatarMap from "./qatar.json"
import { useTranslation } from "react-i18next"
import { Button } from "reactstrap"
const colorPalette = [
  "#4CAF50",
  "#81C784",
  "#27AE60",
  "#27AE6052",
  "#27AE6014",
  "#27AE6029",
  "#27AE607A",
  "#27AE6052",
  "#27AE607A",
  "#F06292",
  "#AED581",
  "#7986CB",
  "#FDD835",
  "#A1887F",
  "#90CAF9",
]

export const AreaActive = () => {
  const { t } = useTranslation()

  const regionColors = useMemo(() => {
    const map: Record<string, string> = {}
    qatarMap.layers.forEach((layer, i) => {
      map[layer.name] = colorPalette[i % colorPalette.length]
    })
    return map
  }, [])

  const [hovered, setHovered] = useState("None")
  const [clicked, setClicked] = useState("None")

  const handleEnter = (e: React.MouseEvent<SVGPathElement, MouseEvent>) => {
    const name = e.currentTarget.getAttribute("name") || "Unknown"
    setHovered(name)
  }

  const handleLeave = () => setHovered("None")

  const handleClick = (e: React.MouseEvent<SVGPathElement, MouseEvent>) => {
    const name = e.currentTarget.getAttribute("name") || "Unknown"
    setClicked(name)
  }

  const activeNewAreaHandler = useCallback(()=>{},[])

  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard") as string}
          breadcrumbItem={t("customers_customers")}
          subBreadcrumbItem={t("customers_activeArea")}
        />
        <Button
          onClick={activeNewAreaHandler}
          className="bg-gradiant-blue border-0 text-capitalize"
        >
          {t("customers_activeNewArea")}
        </Button>
      </div>
      <div className="container-fluid">
        <div style={{ width: "500px", margin: "auto" }}>
          <svg
            viewBox={qatarMap.viewBox}
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: "100%", height: "auto" }}
          >
            {qatarMap.layers.map(layer => (
              <path
                key={layer.id}
                name={layer.name}
                d={layer.d}
                fill={
                  hovered === layer.name ? "#2b8a3e" : regionColors[layer.name]
                }
                stroke="#fff"
                strokeWidth={1}
                cursor="pointer"
                onMouseEnter={handleEnter}
                onMouseLeave={handleLeave}
                onClick={handleClick}
              />
            ))}
          </svg>
        </div>

        <div className="mt-3 text-center">
          <p>
            {t("customers_hovered")}: <strong>{hovered}</strong>
          </p>
          <p>
            {t("customers_clicked")}: <strong>{clicked}</strong>
          </p>
        </div>
      </div>
    </div>
  )
}
